module.exports = __webpack_public_path__ + "img/it_it_day-16.51a37b44.svg";